export default {
  url: {
    apiUrlhttps: 'https://api.nallaienterprise.com/api/v1.0/',
  },
};
